import React from 'react';
import '../pageFarewell.css';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';

const PageFarewellSelfcare360 = ({ selectedEvaluation, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <div className='farewell-page-text'>
                        Este informe refleja tu potencial y oportunidades de mejora, para trazar una ruta de crecimiento profesional acorde a los objetivos de tu organización.
                        En Mentoring nos enfocamos en empoderar el talento humano y potenciar habilidades blandas para un desempeño extraordinario.
                        <br />
                        <br />
                        Creemos en tu capacidad de alcanzar nuevas metas que contribuyan al éxito colectivo.
                        <br />
                        <br />
                        Aprovecha las herramientas que tu empresa pone a disposición, y únete al equipo para materializar sus sueños más ambiciosos. El compromiso,
                        la proactividad y trabajo en equipo son claves en este camino.
                        <br />
                        <br />
                        Tu aporte individual marca la diferencia en la construcción de una organización de alto desempeño. ¡Adelante! El futuro depende del talento
                        y esfuerzo que invirtamos hoy.
                        <br />
                        <br />
                        Juntos llegaremos más lejos...
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageFarewellSelfcare360;
